import { useCallback, useEffect, useState } from 'react';
import UserShowsPage from '../components/UserShowsPage';
import { Link, useParams } from '../util/router';
import { requireAuth, useAuth } from '../util/auth';
import { useUserShowsStore } from '../stores';
import { getWantToSeeDataByUser } from '../util/db';

function WantToSeePage() {
  const { userId } = useParams();
  const auth = useAuth();
  const isOwner = auth.user?.id === userId;
  const wantToSeeShows = useUserShowsStore(s => s.wantToSeeShows);
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setShows(await getWantToSeeDataByUser(userId));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    load();
  }, [load, isOwner ? wantToSeeShows : null]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <UserShowsPage
      userId={userId}
      heading="Want to See"
      subtitle="Upcoming and on-view shows saved to visit"
      shows={shows}
      loading={loading}
      source="want_to_see"
      onSeenToggle={(showId, result) =>
        result?.added && setShows(prev => prev.filter(s => s.show_id !== showId))
      }
      empty={
        <>
          Nothing saved yet. Tap the bookmark on any show in the{' '}
          <Link to="/feed" className="text-secondary-red underline">
            feed
          </Link>{' '}
          to add it here.
        </>
      }
    />
  );
}

export default requireAuth(WantToSeePage);
